import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-eagle-strategies",
    component: _cffe3db6,
    name: "about-eagle-strategies"
  }, {
    path: "/contact",
    component: _cffe3db6,
    name: "contact"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/larry-beebe",
    component: _cffe3db6,
    name: "larry-beebe"
  }, {
    path: "/megan-evans",
    component: _cffe3db6,
    name: "megan-evans"
  }, {
    path: "/the-nautilus-group",
    component: _cffe3db6,
    name: "the-nautilus-group"
  }, {
    path: "/thomas-j-fields",
    component: _cffe3db6,
    name: "thomas-j-fields"
  }, {
    path: "/about/about-our-firm",
    component: _cffe3db6,
    name: "about-our-firm"
  }, {
    path: "/about/our-alliances",
    component: _cffe3db6,
    name: "our-alliances"
  }, {
    path: "/about/our-process",
    component: _cffe3db6,
    name: "our-process"
  }, {
    path: "/about/our-team",
    component: _cffe3db6,
    name: "our-team"
  }, {
    path: "/about/who-we-serve",
    component: _cffe3db6,
    name: "who-we-serve"
  }, {
    path: "/resources/calculators",
    component: _cffe3db6,
    name: "calculators"
  }, {
    path: "/resources/newsletters",
    component: _cffe3db6,
    name: "newsletters"
  }, {
    path: "/resources/upcoming-events",
    component: _cffe3db6,
    name: "upcoming-events"
  }, {
    path: "/resources/video-library",
    component: _cffe3db6,
    name: "video-library"
  }, {
    path: "/services/business-solutions",
    component: _cffe3db6,
    name: "business-solutions"
  }, {
    path: "/services/life-plan-for-your-business",
    component: _cffe3db6,
    name: "life-plan-for-your-business"
  }, {
    path: "/services/lifetime-wealth-portfolio",
    component: _cffe3db6,
    name: "lifetime-wealth-portfolio"
  }, {
    path: "/services/personal-solutions",
    component: _cffe3db6,
    name: "personal-solutions"
  }, {
    path: "/services/working-with-other-advisors",
    component: _cffe3db6,
    name: "working-with-other-advisors"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "evans-beebe-fields-financial-group"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
